module.exports = __webpack_public_path__ + "static/media/bolivia.aec415d8.jpg";